/* global axios */
import ApiClient from './ApiClient';

// SiteUp (Cartões de Apoio): contexto do lead da barra sob o cabeçalho da
// conversa. Um GET só, gated no backend pela feature flag 'lead_context_panel'.
class LeadContextAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  get(conversationId) {
    return axios.get(`${this.url}/${conversationId}/lead_context`);
  }
}

export default new LeadContextAPI();
